module.exports = __webpack_public_path__ + "img/pingjia8.a677ab93.png";